import Link from "next/link"
import { useRouter } from "next/router"

export function Crumb({ text, href, last }) {
  return (
    <li className="inline-block font-tertiary capitalize">
      {last ? (
        <div className="font-bold" aria-current="page">
          {text}
        </div>
      ) : (
        <Link
          href={href}
          className="crumb relative pr-6 text-teal-dark after:absolute after:right-2 after:text-gray after:content-['/'] hover:underline"
        >
          {text}
        </Link>
      )}
    </li>
  )
}

export default function Breadcrumbs() {
  const router = useRouter()

  function generateBreadcrumbs() {
    const asPathNestedRoutes = router.asPath
      .split("?")[0] // Removes query parameter
      .split("#")[0] // Removes hashes
      .split("/") // Creates array of path segments
      .filter((v) => v.length > 0) // Removes any empty elements

    const crumblist = asPathNestedRoutes.map((subpath, idx) => {
      const href = "/" + asPathNestedRoutes.slice(0, idx + 1).join("/")
      let text = subpath.replaceAll("-", " ")
      if (text.length > 30) {
        text = `${text.substring(0, 30)}...`
      }
      return { href, text }
    })

    return [{ href: "/", text: "Home" }, ...crumblist]
  }
  const breadcrumbs = generateBreadcrumbs()

  return (
    <nav aria-label="Breadcrumb" className="px-6 py-6">
      <ol className="mx-auto w-full max-w-screen-xl">
        {breadcrumbs.map((crumb, idx) => (
          <Crumb {...crumb} key={idx} last={idx === breadcrumbs.length - 1} />
        ))}
      </ol>
    </nav>
  )
}
